export default "__VITE_ASSET__B81E2p7i__"